<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-3 p-5">
        <tt-input ttLabel="businessco_no" [ttModel]="setting.businessco_no" ttReadonly></tt-input>
        <tt-input ttLabel="businessco_companyname" [ttModel]="setting.businessco_companyname" ttReadonly></tt-input>
        <tt-input ttLabel="invoice_cust_no" [ttModel]="setting.invoice_cust_no" ttReadonly></tt-input>
        <tt-input ttLabel="cust_name" [ttModel]="setting.cust_name" ttReadonly></tt-input>
        <tt-date ttLabel="invoice_date" [(ttModel)]="setting.invoice_date"></tt-date>
        <tt-button ttText="customerinvoicing_make_invoice" (ttClick)="createChanges()" [ttSpin]="creatingInvoice" ttIcon="fas fa-sync"></tt-button>
        <tt-button ttText="customerinvoicing_set_not_invoicing" (ttClick)="setNotChanges()" [ttSpin]="settingNotInvoice" ttType="danger" ttIcon="fas fa-sync"></tt-button>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
</tt-page>
